import { BoxResourceType } from './types';

export function getTokenDataKey(
  resourceType: BoxResourceType,
  resourceId: string
) {
  return `${resourceType}/${resourceId}`;
}
